import React from "react";
import './App.scss'

import {
  About,
  Footer,
  Header,
  Skills,
  Testimonials,
  Work,
  Blog,
} from "./containers";
import { Navbar } from "./components";
const App = () => {
  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Testimonials />
      <Blog />
      <Footer />
    </div>
  );
};

export default App;
